<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div
          :class="tokenObj.UserType == userTypeInstructor ? 'col mt-4' : 'col'"
        >
          <h3 class="page-title">
            {{
              tokenObj.UserType == userTypeInstructor
                ? "Class Booking"
                : "View Class Booking"
            }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Detail -->
    <div class="row" v-if="classBooking">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Booking Summary</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Submitted by</b></label>
                <div>
                  {{ classBooking.SubmittedBy }} at
                  {{ classBooking.SubmittedDateDisplay }}
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>School</b></label>
                <div>{{ classBooking.SchoolName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Student Name</b></label>
                <div>{{ classBooking.StudentName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Email</b></label>
                <div>{{ classBooking.StudentEmail }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Class Subject</b></label>
                <div>{{ classBooking.SubjectName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Subject Level</b></label>
                <div>{{ classBooking.SubjectLevelName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Duration</b></label>
                <div>{{ classBooking.Duration }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Make-up Class</b></label>
                <div>{{ classBooking.MakeupClass }}</div>
              </div>
            </div>
            <div class="form-row" v-if="classBooking.Location">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Location</b></label>
                <div>{{ classBooking.Location }}</div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="classBooking.Location == 'School Address'"
              >
                <label class="mb-0"><b>School Address</b></label>
                <div>{{ classBooking.LocationSchoolAddressName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Date</b></label>
                <div>{{ classBooking.BookingDateDisplay }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Time</b></label>
                <div>{{ classBooking.BookingTime }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Instructor</b></label>
                <div>{{ classBooking.InstructorName }}</div>
              </div>
              <div class="form-group col-md-6" v-if="classBooking.Remarks">
                <label class="mb-0"><b>Remarks</b></label>
                <div>{{ classBooking.Remarks }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card" v-if="classBooking.MakeupClass == 'No'">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Payment</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Total</b></label>
                <div>
                  {{ classBooking.Currency }} {{ classBooking.FeeAmountPaid }}
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Payment Option</b></label>
                <div>{{ classBooking.PaymentOption }}</div>
              </div>
            </div>

            <template
              v-if="classBooking.PaymentOption == 'Electronic Bank Transfer'"
            >
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>UEN</b></label>
                  <div>{{ classBooking.UEN }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>SWIFT Code</b></label>
                  <div>{{ classBooking.SwiftCode }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Account Number</b></label>
                  <div>{{ classBooking.AccountNumber }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Account Name</b></label>
                  <div>{{ classBooking.AccountName }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Bank Name</b></label>
                  <div>{{ classBooking.BankName }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Bank Address</b></label>
                  <div>{{ classBooking.BankAddress }}</div>
                </div>
              </div>
              <div class="form-row" v-if="classBooking.PaymentProof">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Payment File</b></label>
                  <div>
                    <button
                      type="button"
                      class="btn btn-link p-0"
                      @click="downloadPaymentProof"
                    >
                      {{ classBooking.PaymentProofFileName }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <div
              class="form-row"
              v-if="
                classBooking.PaymentOption == 'QR Payment' ||
                classBooking.PaymentOption == 'Crossed Cheque'
              "
            >
              <div
                class="form-group col-md-6"
                v-if="classBooking.PaymentOption == 'QR Payment'"
              >
                <label class="mb-0"><b>UEN</b></label>
                <div>{{ classBooking.UEN }}</div>
              </div>
              <div class="form-group col-md-6" v-if="classBooking.PaymentProof">
                <label class="mb-0"><b>Payment File</b></label>
                <div>
                  <button
                    type="button"
                    class="btn btn-link p-0"
                    @click="downloadPaymentProof"
                  >
                    {{ classBooking.PaymentProofFileName }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Status</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Status</b></label>
                <div>{{ classBooking.Status }}</div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="classBooking.ConfirmedDateDisplay"
              >
                <label class="mb-0"><b>Confirmed by</b></label>
                <div>
                  {{ classBooking.ConfirmedBy }} at
                  {{ classBooking.ConfirmedDateDisplay }}
                </div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="
                  !classBooking.ConfirmedDateDisplay &&
                  classBooking.CancelledDateDisplay
                "
              >
                <label class="mb-0"><b>Cancelled by</b></label>
                <div>
                  {{ classBooking.CancelledBy }} at
                  {{ classBooking.CancelledDateDisplay }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div
                class="form-group col-md-6"
                v-if="
                  classBooking.ConfirmedDateDisplay &&
                  classBooking.CancelledDateDisplay
                "
              >
                <label class="mb-0"><b>Cancelled by</b></label>
                <div>
                  {{ classBooking.CancelledBy }} at
                  {{ classBooking.CancelledDateDisplay }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Detail -->

    <!-- Button -->
    <div class="text-center desktop-show" v-if="classBooking">
      <router-link
        v-if="
          tokenObj.UserType == userTypeMainAdmin ||
          tokenObj.UserType == userTypeSchoolAdmin ||
          tokenObj.UserType == userTypeInstructorSchoolAdmin
        "
        class="btn btn-primary mr-4"
        :to="{
          name:
            tokenObj.UserType == userTypeMainAdmin
              ? 'mainAdminClassBookingList'
              : 'schoolAdminClassBookingList',
        }"
      >
        <i class="fa fa-reply mr-2"></i>Back to Class Bookings
      </router-link>
      <button
        v-if="classBooking.Status != 'Cancelled'"
        class="btn btn-danger mr-4"
        @click="cancel"
      >
        Cancel Class Booking
      </button>
      <button
        v-if="classBooking.Status == 'Pending Confirmation'"
        class="btn btn-success"
        @click="confirm"
      >
        Confirm
      </button>
    </div>
    <!-- /Button -->

    <!-- Button Mobile -->
    <div class="mobile-show" v-if="classBooking">
      <div class="row" v-if="classBooking.Status != 'Cancelled'">
        <div class="form-group col-12">
          <button class="btn btn-danger form-control" @click="cancel">
            Cancel Class Booking
          </button>
        </div>
      </div>
      <div class="row" v-if="classBooking.Status == 'Pending Confirmation'">
        <div class="form-group col-12">
          <button class="btn btn-success form-control" @click="confirm">
            Confirm
          </button>
        </div>
      </div>
      <div
        class="row"
        v-if="
          tokenObj.UserType == userTypeMainAdmin ||
          tokenObj.UserType == userTypeSchoolAdmin ||
          tokenObj.UserType == userTypeInstructorSchoolAdmin
        "
      >
        <div class="form-group col-12">
          <router-link
            class="btn btn-primary form-control"
            style="padding-top: 11px"
            :to="{
              name:
                tokenObj.UserType == userTypeMainAdmin
                  ? 'mainAdminClassBookingList'
                  : 'schoolAdminClassBookingList',
            }"
          >
            <i class="fa fa-reply mr-2"></i>Back to Class Bookings
          </router-link>
        </div>
      </div>
    </div>
    <!-- /Button Mobile -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      classBooking: null,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    getClassBookingDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classBooking = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    downloadPaymentProof() {
      const base64String = this.classBooking.PaymentProof.split(",")[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = this.classBooking.PaymentProofFileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    cancel() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to cancel the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .cancelClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                if (this.tokenObj.UserType == this.userTypeInstructor) {
                  this.$router.replace({ name: "instructorMySchedule" });
                } else {
                  this.$router.replace({
                    name:
                      this.tokenObj.UserType == this.userTypeMainAdmin
                        ? "mainAdminClassBookingList"
                        : "schoolAdminClassBookingList",
                  });
                }
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    confirm() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to confirm the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .confirmClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                if (this.tokenObj.UserType == this.userTypeInstructor) {
                  this.$router.replace({ name: "instructorMySchedule" });
                } else {
                  this.$router.replace({
                    name:
                      this.tokenObj.UserType == this.userTypeMainAdmin
                        ? "mainAdminClassBookingList"
                        : "schoolAdminClassBookingList",
                  });
                }
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    //if no token,redirect to login
    if (!this.tokenObj) {
      this.$router.replace({ name: "schoolUserLogin" });
      return;
    } else {
      if (this.tokenObj.UserType == this.userTypeStudent) {
        this.$router.replace({ name: "studentClassBookingForm" });
        return;
      } else if (
        this.tokenObj.UserType == this.userTypeMainAdmin ||
        this.tokenObj.UserType == this.userTypeSchoolAdmin ||
        this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin
      ) {
        if (this.$route.name == "classBookingRequest") {
          this.$router.replace({
            name:
              this.tokenObj.UserType == this.userTypeMainAdmin
                ? "mainAdminClassBookingShow"
                : "schoolAdminClassBookingShow",
            params: { id: this.$route.params.id },
          });
        }
      }
    }
    this.getClassBookingDetail();
  },
};
</script> 

<style scoped>
.btn-link {
  color: #007bff !important;
}
.desktop-show {
  display: block;
}
.mobile-show {
  display: none;
}

@media only screen and (max-width: 767.98px) {
  .w-xs-40 {
    width: 40% !important;
  }
  .w-xs-50 {
    width: 50% !important;
  }
  .desktop-show {
    display: none;
  }
  .mobile-show {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingShow.vue